import React, { useEffect, useMemo, useRef, useState } from "react";
import clsx from "clsx";
import ReactPlayer from "react-player";
import makeStyles from "@material-ui/styles/makeStyles";
import ReactSVGIcon from "@micado-digital/react-svg-icon/ReactSVGIcon";

const useStyles = makeStyles(theme => ({
	video: {
		height: "100%",
		position: "relative",
		width: "100%",
		zIndex: 1,
		"&::before": {
			bottom: 0,
			content: "''",
			left: 0,
			position: "absolute",
			right: 0,
			top: 0,
			zIndex: 2
		}
	},
	soundControl: {
		alignItems: "center",
		background: "rgba(0,0,0,0.5)",
		bottom: 0,
		borderRadius: "50%",
		cursor: "pointer",
		display: "flex",
		height: 48,
		justifyContent: "center",
		left: theme.spacing(1),
		position: "absolute",
		transform: "translate(-50%, 48px)",
		transition: "transform 800ms ease 2s",
		width: 48,
		zIndex: 100,
		[theme.breakpoints.up("sm")]: {
			left: "50%"
		}
	},
	soundControlVisible: {
		transform: "translate(0, -8px)",
		[theme.breakpoints.up("sm")]: {
			transform: "translate(-50%, -24px)"
		}
	}
}));

const Video = ({ absoluteMediaURLs, media, playAnimation, show, stopAnimation, type }) => {
	const { REACT_APP_PATH } = process.env;
	const { filename } = media || {};
	const [height, setHeight] = useState("100%");
	const [mute, setMute] = useState(true);
	const [playing, setPlaying] = useState(false);
	const [width, setWidth] = useState("100%");
	const containerRef = useRef();
	const playerRef = useRef();
	const css = useStyles();

	useEffect(() => {}, []);

	useEffect(() => {
		if (!show) return;

		setPlaying(true);

		playerRef.current.seekTo(0);

		stopAnimation();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [show]);

	useEffect(() => {
		if (!containerRef?.current) return;

		const element = containerRef.current;

		window.addEventListener("resize", () => resize(element));

		resize(element);

		return () => window.removeEventListener("resize", () => resize(element));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [containerRef]);

	const url = useMemo(() => {
		if (type === "youtubevideo") {
			return `https://www.youtube.com/embed/${filename}?autohide=0&controls=0&showinfo=0&modestbranding=1&rel=0&iv_load_policy=3&playsinline=1&wmode=transparent`;
		} else if (type === "videofile") {
			return `${!absoluteMediaURLs ? REACT_APP_PATH : ""}${filename}`;
		}
	}, [REACT_APP_PATH, absoluteMediaURLs, filename, type]);

	const resize = element => {
		let rootWidth = element.offsetWidth;
		let rootHeight = element.offsetHeight;

		let videoWidth = 0;
		let videoHeight = 0;

		videoWidth = Math.ceil(rootHeight * 1.7777777);
		videoHeight = Math.ceil(rootHeight);

		if (rootWidth > videoWidth) {
			videoWidth = Math.ceil(rootWidth);
			videoHeight = Math.ceil(videoWidth / 1.7777777);
		}

		setHeight(videoHeight);
		setWidth(videoWidth);
	};

	const handleEnded = () => {
		setPlaying(false);

		playAnimation();
	};

	const handleSound = () => {
		setMute(!mute);
	};

	return (
		<div className={css.video} ref={containerRef}>
			{show && (
				<ReactPlayer
					controls={false}
					height={height}
					muted={true}
					playing={playing}
					ref={playerRef}
					url={url}
					width={width}
					onEnded={handleEnded}
				/>
			)}
			<div
				className={clsx("mco-animation-01__sound-control", css.soundControl, {
					[css.soundControlVisible]: show
				})}
				onClick={handleSound}
			>
				<ReactSVGIcon
					color="paper"
					src={`/img/icons/${mute ? "mute.svg" : "sound.svg"}`}
					size={24}
				/>
			</div>
		</div>
	);
};

export default Video;
